import { works as worksRaw, editorPicks as editorPicksRaw } from "@/mocks/works";
import type { Work, EditorPick } from "@/types/work";

export const works = worksRaw as unknown as Work[];
export const editorPicks = editorPicksRaw as unknown as EditorPick[];